import { createFileRoute } from '@tanstack/react-router';
import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';

export const Route = createFileRoute('/sso-callback')({
  component: SSOCallbackPage,
});

function SSOCallbackPage() {
  return (
    <AuthenticateWithRedirectCallback
      signInForceRedirectUrl="/"
      signUpForceRedirectUrl="/"
    />
  );
}
